import React from 'react';
import HandoffShell from './HandoffShell';
import HandoffWaveform from './HandoffWaveform';

// The "Signing you in" waiting screen — the looping waveform with a breathing
// label. Used for session bootstrap (AuthGate / AuthGateUI) and, with a
// plugin-specific `detail`, the handoff pending state.
export function HandoffLoading({
    label = 'Signing you in',
    detail = 'One moment while we get you set up.',
}: {
    label?: string;
    detail?: string;
}) {
    return (
        <HandoffShell
            waveform={<HandoffWaveform mode="loading" />}
            label={label}
            detail={detail}
            pulse
        />
    );
}

export default HandoffLoading;
